export enum ActionType {
  SET_USER = "SET_USER",
  SET_USER_ROLE = "SET_USER_ROLE",
  SET_ACCOUNT_ACTIVE_STATE = "SET_ACCOUNT_ACTIVE_STATE",
  SET_AUTH_STATE = "SET_AUTH_STATE",
  SET_APPSLIST = "SET_APPSLIST",
  SET_ACCOUNTINFO = "SET_ACCOUNTINFO",
  SET_USERSETTINGS = "SET_USERSETTINGS",
  SET_TOKEN = "SET_TOKEN",
  SET_ENCODED_TOKEN = "SET_ENCODED_TOKEN",
}
